import React from 'react';
import { Section } from './Section';
import { MessageCircleHeart } from 'lucide-react';
import { motion } from 'framer-motion';
export function ProofSection() {
  const testimonials = [{
    text: 'Me ayudó a organizarme y dejar de sentirme tan pesada al final del día. Lo mejor es que está súper fácil de seguir.',
    name: 'María G.',
    photo: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop&crop=face'
  }, {
    text: 'Sentí más control, menos inflamación y me encantó que todo está pensado para mujeres como nosotras que vivimos en USA.',
    name: 'Carolina R.',
    photo: 'https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?w=100&h=100&fit=crop&crop=face'
  }, {
    text: 'En 3 días noté una diferencia enorme en cómo me quedaba la ropa. Ya no sentía esa pesadez después de comer y mi energía cambió por completo.',
    name: 'Lucía M.',
    photo: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop&crop=face'
  }, {
    text: 'Llevaba meses sintiéndome inflamada sin saber qué hacer. Esta guía me dio claridad y resultados reales sin tener que volverme loca con dietas extremas.',
    name: 'Valentina P.',
    photo: 'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=100&h=100&fit=crop&crop=face'
  }];
  return <Section className="bg-sage pb-6 md:pb-16" data-id="element-314">
      <div className="text-center mb-12" data-id="element-315">
        <MessageCircleHeart className="w-12 h-12 text-forest mx-auto mb-4" data-id="element-316" />
        <h2 className="font-serif text-3xl md:text-4xl text-forest font-bold mb-6" data-id="element-317">
          Lo que otras mujeres han sentido con esta guía
        </h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-5xl mx-auto" data-id="element-318">
        {testimonials.map((item, index) => <div key={index} className="bg-white p-8 rounded-2xl shadow-lg relative" data-id="element-319">
            <div className="text-gold text-4xl font-serif absolute top-4 left-4 opacity-30" data-id="element-320">
              "
            </div>
            <p className="text-gray-700 text-lg italic relative z-10 pt-4" data-id="element-321">
              {item.text}
            </p>
            <div className="mt-6 flex items-center gap-3" data-id="element-322">
              <img src={item.photo} alt={item.name} className="w-10 h-10 rounded-full object-cover" data-id="element-323" />
              <span className="font-semibold text-forest" data-id="element-324">{item.name}</span>
            </div>
            <div className="mt-3 flex text-gold" data-id="element-325">
              {'★★★★★'.split('').map((star, i) => <span key={i} data-id="element-326">{star}</span>)}
            </div>
          </div>)}
      </div>
      <div className="text-center mt-10" data-id="element-327">
        <motion.button animate={{
        scale: [1, 1.03, 1],
        boxShadow: ['0 0 0 0 rgba(212, 175, 55, 0.4)', '0 0 20px 8px rgba(212, 175, 55, 0.3)', '0 0 0 0 rgba(212, 175, 55, 0.0)']
      }} transition={{
        duration: 2,
        repeat: Infinity,
        ease: 'easeInOut'
      }} whileHover={{
        scale: 1.05
      }} whileTap={{
        scale: 0.97
      }} onClick={() => document.getElementById('offer')?.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      })} className="inline-block bg-gold hover:bg-gold-hover text-forest font-bold py-4 px-8 rounded-full shadow-lg transition-colors text-lg md:text-xl w-full md:w-auto text-center cursor-pointer" data-id="element-328">
          Quiero decirle adiós a la hinchazón
        </motion.button>
        <p className="text-sm text-gray-700 font-medium mt-4" data-id="element-329">
          Mira el precio, los bonos incluidos y los extras opcionales antes de
          comprar.
        </p>
      </div>
    </Section>;
}